import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import '@descomplica/vue-components/dist/vueComponents.css';
import VueCookies from 'vue-cookies';
import VueGtag from 'vue-gtag';
import SentryClient from './helpers/sentry';
import PluginGTMManager from './plugins/gtm-plugin';
import ViewsNames from './router/viewsNames';

Vue.use(VueCookies);

Vue.config.productionTip = false;

const areTrackingsEnabled = JSON.parse(process.env.VUE_APP_ENABLE_TRACKINGS || 'false');

if (areTrackingsEnabled) {
  window.POCKET_ENV = {
    hubspot: process.env.VUE_APP_HUBSPOT_ID,
    mixpanel: process.env.VUE_APP_MIXPANEL_TOKEN,
  };

  Vue.use(VueGtag, { config: { id: process.env.VUE_APP_GA_TOKEN } }, router);
  Vue.use(PluginGTMManager, {
    gtmId: process.env.VUE_APP_GTM_TOKEN,
    autoInstall: false,
    routerOptions: {
      vueRouter: router,
      entryPath: ViewsNames.RESULT,
    },
  });
}

SentryClient.enableSentry();

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
